import React from "react";
import styled from "styled-components";
import "@fontsource/ibm-plex-mono";

const TermsContainer = styled.div`
  position: relative;
  background-color: white;
  padding-bottom: 3%;
  padding-left: min(4%, 40px);
  padding-right: min(4%, 40px);
`;

const Title = styled.h2`
  color: #000000;
  font-family: "IBM Plex Mono", Helvetica, monospace;
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 20px;
  margin-top: 20px;
  text-align: center;
`;

const SectionTitle = styled.h3`
  color: #000000;
  font-family: "IBM Plex Mono", Helvetica, monospace;
  font-size: 18px;
  font-weight: 600;
  margin: 15px 0 10px 0;
`;

const Text = styled.p`
  color: #000000;
  font-family: "IBM Plex Mono", Helvetica, monospace;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  margin: 8px 0;
  text-indent: 2.5em;
  text-align: justify;
`;

const ListItem = styled.li`
  color: #000000;
  font-family: "IBM Plex Mono", Helvetica, monospace;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  margin: 8px 0;
  text-align: justify;  
`;

const UnorderedList = styled.ul`
  padding-left: 20px;
`;

const OrderedList = styled.ol`
  counter-reset: item;
  
  @media(min-width: 1024px) {
    padding-left: 30px;
  }

  li {
    display: block;
    counter-increment: item;
    margin: 8px 0;
    padding-left: 4em;
    position: relative;
  }

  li::before {
    content: counters(item, ".") ". ";
    position: absolute;
    left: 0;
    min-width: 3.5em;
    text-align: right;
    white-space: nowrap;
  }

  li:has(h3)::before {
    content: "";
  }

  li:has(h3) {
    padding-left: 0;
  }
`;

const TermsOfUse: React.FC = () => {
  return (
    <TermsContainer>
      <Title>Умови використання сайту</Title>
      
      <SectionTitle>ПУБЛІЧНА ОФЕРТА</SectionTitle>
      
      <SectionTitle>Преамбула</SectionTitle>
      
      <Text>
        Шановний Користувач сайту www.barkovbooks.com, звертаємо Вашу увагу, що
        використання в будь-якому вигляді Сайту (в тому числі, але не
        обмежуючись розміщенням Вами Замовлень товарів з використанням сайту
        www.barkovbooks.com, участь в бонусних програмах, акціях, заповнення
        заявок, форм і т.п.) означає, що Ви ознайомлені та згодні з умовами
        використання Сайту www.barkovbooks.com, а також є акцептом Вами даної
        Публічної оферти. Дана Публічна оферта є обов'язковою для виконання
        сторонами. У разі Вашої незгоди з умовами даної Публічної оферти, Ви
        повинні утриматися від використання сайту www.barkovbooks.com.
      </Text>

      <SectionTitle>ВИЗНАЧЕННЯ ТЕРМІНІВ</SectionTitle>
      
      <UnorderedList>
        <ListItem>
          <strong>Адміністрація</strong> - адміністрація інтернет-магазину «BarkovBooks», що
          розміщений на вeб-сайті www.barkovbooks.com, Товариство з
          обмеженою відповідальністю «Сітон», зареєстроване в Україні,
          місцезнаходження за адресою: 04200, м. Київ, вул. Дубровицька, 28
        </ListItem>
        
        <ListItem>
          <strong>Акційний контент</strong> - контент, що може бути доступний для
          завантаження за акційною ціною протягом певного проміжку часу про що
          буде поінформовано у відповідному розділі на сайті.
        </ListItem>
        
        <ListItem>
          <strong>Замовлення</strong> - належним чином оформлений і розміщений запит Покупця
          (заповнені відповідні поля на сайті в розділі «Оформлення замовлення»),
          адресований Продавцю, з пропозицією здійснити продаж обраного на сайті
          переліку Товару, із зазначенням його кількості.
        </ListItem>
        
        <ListItem>
          <strong>Користувач</strong> - фізична особа, яка досягла 18-річного віку, що
          володіє повною дієздатністю, що використовує даний сайт і/або його
          окремі інструменти, яка погодилася з умовами Публічної оферти і виконала
          всі її умови описані нижче.
        </ListItem>
        
        <ListItem>
          <strong>Контент</strong> - товар, що представлений на сайті
          www.barkovbooks.com у вигляді текстових, зображувальних, аудіо та відео файлів, 
          що надані у різних форматах та представлені для огляду, скачування та інших дій
          Користувачем.
        </ListItem>
        
        <ListItem>
          <strong>Обліковий запис</strong> - унікальні облікові та персональні дані
          Користувача, які ідентифікують Користувача на Сайті, зберігаються на
          апаратних ресурсах Адміністрації та надають Користувачеві можливість
          використання функціоналу Сайту, відповідно до умов цієї Угоди.
        </ListItem>
        
        <ListItem>
          <strong>Одержувач</strong> - особа, зазначена Платником у розділі «Оформлення
          замовлення», в якості особи, що уповноважена отримати товар. Якщо інше
          не зазначено в розділі «Оформлення замовлення», Одержувачем є Платник.
        </ListItem>
        
        <ListItem>
          <strong>Особистий кабінет</strong> - комплекс програмних функцій Сайту, які
          дозволяють Користувачеві, який авторизувався належним чином в свій
          Обліковий запис, отримувати інформацію про здійснені ним Замовлення,
          покупки, вносити зміни в облікові та персональні дані Користувача та
          отримувати доступ до придбаного Контенту.
        </ListItem>
        
        <ListItem>
          <strong>Платник</strong> - особа, яка здійснює оплату замовлення Покупця, якщо інше
          не зазначено в розділі «Оформлення замовлення», Платником є Покупець.
        </ListItem>
        
        <ListItem>
          <strong>Покупець</strong> - зареєстрований Користувач, що здійснює замовлення та
          має намір придбати/купує товари, пропоновані до продажу Продавцем та
          представлені на сайті www.barkovbooks.com
        </ListItem>
        
        <ListItem>
          <strong>Покупець контенту</strong> - Покупець, що отримує можливість і здійснює
          завантаження, пропонованого на сайті www.barkovbooks.com контенту.
        </ListItem>
        
        <ListItem>
          <strong>Правовласник</strong> - власник Контенту.
        </ListItem>
        
        <ListItem>
          <strong>Продавець</strong> - Товариство з обмеженою відповідальністю «Сітон».
        </ListItem>
        
        <ListItem>
          <strong>Пропозиція</strong> - відомості про товар, розміщені Продавцем на сайті,
          які включають в себе інформацію про товар, його ціну, способи оплати та
          доставки, інформацію про знижки та акційні пропозиції на товар, а також
          інші умови придбання товару. Умови Пропозицій, розміщених на сайті,
          встановлюються Продавцем. Пропозиція є інформацією про можливі умови
          покупки товару.
        </ListItem>
        
        <ListItem>
          <strong>Сайт</strong> - вeб-сайт, що має адресу в мережі інтернет
          www.barkovbooks.com, на окремих сторінках (в розділах) якого розміщено 
          правила (умови) реєстрації, оформлення замовлення, бонусної програми, 
          оплати, доставки, повернення товару, гарантії тощо, а також міститься 
          інформація про Покупця (контактні дані, замовлення, адреси доставки, та ін.), 
          за допомогою якого Користувач має можливість здійснити покупку бажаного товару.
        </ListItem>
        
        <ListItem>
          <strong>Товар</strong> - матеріальний об'єкт, пропонований до продажу Продавцем,
          розміщений на сайті, щодо якого вказана ціна, назва, опис,
          характеристики та зазначено статус його доступності.
        </ListItem>
        
        <ListItem>
          <strong>Угода</strong> - дана публічна оферта, включаючи всі її умови та додатки до
          неї.
        </ListItem>
      </UnorderedList>

      <OrderedList>
        <ListItem>
          <SectionTitle>Загальні положення</SectionTitle>
          <OrderedList>
            <ListItem>
              Ця Угода регулює порядок доступу Користувача до інформації, що
              розміщується на Сайті, порядок використання Сайту, а також можливість
              передачі товарів та інші умови.
            </ListItem>
            <ListItem>
              Сайт є платформою для розміщення пропозицій про продаж товарів
              Продавцем.
            </ListItem>
            <ListItem>
              Дана угода відповідно до ст. ст. 633, 641 і гл. 63 Цивільного
              кодексу України є Публічним договором (офертою) і адресована
              невизначеному колу осіб не залежно від статусу (фізична особа, юридична
              особа, фізична особа - підприємець), що бажають придбати товари,
              інформація про які міститься на Сайті. Оскільки ця Угода є публічною
              офертою, то отримуючи доступ до матеріалів Сайту Користувач\Покупець
              вважається таким, що приєднався до цієї Угоди.
            </ListItem>
            <ListItem>
              Інформація про товар відображається на Сайті і є динамічною. Це
              означає, що інформація може бути оновлена, змінена і доповнена
              Адміністрацією в будь-який момент часу без попереднього повідомлення про
              це Користувача. Визначені зміни вступають в силу після їх публікації на
              Сайті та застосовуються до будь-якого замовлення, зробленого після їх
              публікації.
            </ListItem>
            <ListItem>
              Інформація про товар Продавця, умови його придбання, ціни та
              будь-яка інша інформація Продавця точно відображається на Сайті.
              Інформація на Сайті про Товар, Контент, Продавця та інші умови роботи
              Сайту та правовідносин між сторонами цієї Угоди слугує лише в якості
              доповнення умов цієї Угоди. У разі суперечності інформації на Сайті
              умовам цієї Угоди, умови Угоди мають перевагу та підлягають
              застосуванню.
            </ListItem>
            <ListItem>
              Ця Угода може бути укладена фізичною особою, яка досягла 18-річного
              віку, що володіє повною дієздатністю, що використовує даний сайт і\або
              його окремі інструменти, яка погодилася з умовами Угоди та повністю
              приймає на себе зобов'язання, що виникають в результаті використання
              Сайту і укладення цієї Угоди.
            </ListItem>
            <ListItem>
              Замовляючи товар на Сайті, Покупець погоджується з усіма умовами
              даної Угоди та її Додатків.
            </ListItem>
            <ListItem>
              Пропозиція на Сайті не є офертою. Однак, Покупець після
              ознайомлення з Пропозицією вправі зробити оферту Продавцю шляхом обрання
              товару та заповнення форми у розділі «Оформлення замовлення». Заповнення
              визначеної форми вважається офертою Покупця Продавцю на придбання
              відповідного товару на умовах, зазначених в Пропозиції. Оферту Продавцю
              вправі зробити і незареєстрований Користувач, при цьому він повинен
              коректно ввести всі необхідні дані у форму «Оформлення замовлення» на
              Сайті.
            </ListItem>
            <ListItem>
              Оферта вважається прийнятою Продавцем (акцепт) якщо останній
              здійснив дії, які свідчать про прийняття оферти Покупця, а саме:
              фактично відвантажив товар відповідно до умов, передбачених офертою
              Покупця або надав доступ та можливість завантажити контент через
              Особистий кабінет Користувача.
            </ListItem>
            <ListItem>
              Після отримання оферти Покупця Продавець має право запропонувати
              придбати товар на інших умовах, ніж було передбачено офертою Покупця. У
              цьому випадку така пропозиція вважається зустрічною офертою і має бути
              прийнята Покупцем. Прийняттям зустрічної оферти вважається фактично
              оплата, отримання Покупцем\Одержувачем товару на умовах, обумовлених
              зустрічною офертою. Продавець має право відкликати таку зустрічну оферту
              до моменту оплати та видачі товару.
            </ListItem>
            <ListItem>
              У випадку помилковості відправленого акцепту Сторони мають право
              змінити умови тільки у випадку вчасного повідомлення про таку
              помилковість одна одну.
            </ListItem>
            <ListItem>
              Достатнім доказом прийняття оферти Продавцем або зустрічної оферти
              (тобто узгодження Сторонами всіх істотних умов продажу товару) є
              фактична його оплата, отримання товару Покупцем\Одержувачем.
            </ListItem>
            <ListItem>
              Не вважається прийняттям Продавцем оферти Покупця направлення
              Продавцем\Адміністрацією засобами електротехнічного (SMS-інформування,
              електронна пошта, телефон і т.п.) або іншого зв'язку повідомлення
              Продавця/Адміністрації про одержання Замовлення Покупця або про терміни
              його отримання і/або про ціну товару. Дане повідомлення є виключно
              повідомленням про отримання Продавцем оферти Покупця (але не про її
              прийняття) і містить відтворення умов оферти, наданої Покупцем.
            </ListItem>
            <ListItem>
              Інформація про Товар розміщена безпосередньо на Сайті, окрім цього
              при отриманні товару, до моменту підписання документів, що
              підтверджують отримання товару, Покупець/Одержувач зобов'язаний
              ознайомитися з інформацією про товар, що міститься на Товарі і/або
              упаковці та/або в товаросупровідних документах. У разі необхідності
              отримання додаткової інформації про товар Покупець/Одержувач
              зобов'язаний зв'язатися з Продавцем та отримати необхідну інформацію
              засобами дистанційного зв'язку до моменту прийняття такого товару.
            </ListItem>
            <ListItem>
              Знижки/акції не сумуються з іншими знижками/акціями і знижками за
              промокодом.
            </ListItem>
            <ListItem>
              Знижка за промокодом не застосовується при купівлі подарункового
              сертифіката.
            </ListItem>
            <ListItem>
              Подарунковим сертифікатом можна оплатити будь-який товар на сайті,
              крім подарункових сертифікатів.
            </ListItem>
            <ListItem>
              Подарунковий сертифікат можна використати лише один раз.
            </ListItem>
            <ListItem>
              Термін дії подарункового сертифіката становить 12 (дванадцять)
              календарних місяців.
            </ListItem>
            <ListItem>
              Якщо протягом строку дії подарункового сертифіката Покупцем не
              буде реалізоване право на придбання товару, то сума, сплачена за
              сертифікат, поверненню не підлягає.
            </ListItem>
            <ListItem>
              Якщо сума чека перевищує номінал сертифіката - Покупцю буде
              необхідно доплатити різницю, але якщо сума менша за номінал, залишок не
              повертається і подарунковий сертифікат буде вважатись використаним.
            </ListItem>
            <ListItem>
              Розділити номінал подарункового сертифіката на декілька різних
              чеків неможливо.
            </ListItem>
            <ListItem>
              Кількість подарункових сертифікатів для оплати покупки необмежена,
              їх можна підсумувати.
            </ListItem>
            <ListItem>
              У разі втрати подарунковий сертифікат не підлягає поверненню чи
              відновленню. Подарунковий сертифікат не підлягає обміну на грошові
              кошти.
            </ListItem>
            <ListItem>
              Власником прав інтелектуальної власності на поширення Контенту,
              представленого на Сайті, є ТОВ «Сітон», що розташоване за адресою
              Україна, 04200, м. Київ, вул. Дубровицька, 28. Використання текстових та
              фото/відео матеріалів Сайту можливо лише з дозволу Адміністрації.
            </ListItem>
            <ListItem>
              Даний сайт: https://www.barkovbooks.com може
              використовуватись іншими суб'єктами господарювання на підставі
              відповідних договорів оренди та/або надання послуг та ін. У свою чергу
              зазначені суб'єкти господарювання матимуть право здійснювати продаж
              товарів кінцевим споживачам, та нестимуть відповідальність по даній
              продукції перед кінцевими споживачами.
            </ListItem>
          </OrderedList>
        </ListItem>

        <ListItem>
          <SectionTitle>Реєстрація на сайті та порядок оформлення Замовлення</SectionTitle>
          <OrderedList>
            <ListItem>
              Для отримання можливості здійснити покупку на сайті Користувач повинен зареєструватися на сайті. Для цього він повинен натиснути кнопку «Вхід» та заповнити реєстраційну форму. Адміністратор залишає за собою право відхилити будь-яку заявку про реєстрацію та/або припинити будь-чию реєстрацію на Сайті.
            </ListItem>
            <ListItem>
              Також Користувач може здійснити Замовлення товару без відповідної реєстрації, але при цьому ним повинні бути коректно заповнені обов'язкові поля у формі «Оформлення замовлення».
            </ListItem>
            <ListItem>
              Під час реєстрації на Сайті, а саме заповнення реєстраційної форми та створення Особистого кабінету, Користувач зобов'язується вказувати інформацію, позначену як обов'язкова, в повному обсязі, а також Користувач несе відповідальність за достовірність, правильність і правдивість як обов'язкової, так і іншої наданої інформації. У разі виявлення будь-якої недостовірності, неправильності або неправдивості інформації, наданої Зареєстрованим Користувачем, Адміністрація Сайту безумовно залишає за собою право в будь-який момент анулювати Обліковий запис такого Зареєстрованого Користувача без будь-яких компенсацій чи відшкодувань.
            </ListItem>
            <ListItem>
              Внесення інформації у реєстраційну форму Сайту, а також оформивши Замовлення, Покупець підтверджує, що ознайомлений з умовами даної Угоди, і всі дії, які їм будуть здійснені, не будуть суперечити умовам цієї Угоди.
            </ListItem>
            <ListItem>
              Замовлення вважається прийнятим до виконання, а Угода між Покупцем і Продавцем — укладеною, після отримання Покупцем електронного повідомлення на адресу електронної пошти від Продавця або шляхом здійснення телефонного дзвінка Продавцем на номер мобільного телефону, що вказані при реєстрації Покупцем, з підтвердженням факту узгодження та приймання Замовлення.
            </ListItem>
            <ListItem>
              Продавець має право відхилити Замовлення в разі фактичної відсутності товару на складі, шляхом надсилання електронного повідомлення чи здійснення телефонного дзвінка Покупцеві. У такому випадку права і обов'язки Сторін, пов'язані з продажем, доставкою і передачею замовленого товару Покупцю і оплатою його Продавцю передбачені даною Угодою, припиняються, а вартість товару, у випадку сплати за нього, повертається Покупцю.
            </ListItem>
            <ListItem>
              У випадку відсутності можливості підтвердження Замовлення Продавцем у Покупця, з причин невірно вказаної адреси електронної пошти чи/та номеру телефону, Продавець має право відмінити таке непідтверджене Замовлення.
            </ListItem>
          </OrderedList>
        </ListItem>

        <ListItem>
          <SectionTitle>Вартість та умови оплати товарів</SectionTitle>
          <OrderedList>
            <ListItem>
              Ціна товару вказана на Сайті у відповідному розділі на момент оформлення Замовлення, і не включає вартість доставки.
            </ListItem>
            <ListItem>
              Продавець має право в односторонньому порядку без попередження змінити ціну на товар. Однак Продавець не має права змінювати ціну замовленого товару після того, як Замовлення було прийнято Продавцем, а Покупець отримав електронне повідомлення або телефонний дзвінок, що підтверджує Замовлення або Покупець здійснив розрахунок за товар.
            </ListItem>
            <ListItem>
              Вартість товару сплачується в національній валюті України – гривні.
            </ListItem>
            <ListItem>
              Покупець може здійснити оплату замовленого Товару: банківською картою Visa або MasterCard на Сайті в момент оформлення Замовлення; перерахувавши грошові кошти безпосередньо перед отриманням Товару, на банківський рахунок Продавця; банківською картою Visa або MasterCard в терміналах, розміщених в відділеннях самовивозу BarkovBooks перед отриманням Замовлення; засобами Бонусного рахунку з урахуванням умов і обмежень, визначених у розділі «Бонусна програма».
            </ListItem>
            <ListItem>
              Користувач/Покупець розуміє і погоджується з тим, що оператором з прийому і проведення платежів за товари, представлені на Сайті, є, залежно від обставин, одна з компаній-екваєрів, підключена до Сайту і обрана самостійно Користувачем/Покупцем у процесі здійснення оплати за товар; або, в рамках відкритого банкінгу, надавачі платіжних послуг з обслуговування рахунків (ASPSP): банки та небанківські надавачі платіжних послуг, у яких відкрито рахунки користувачів.
            </ListItem>
            <ListItem>
              Товар до моменту його передачі Продавцем, повинен бути повністю оплачений Покупцем.
            </ListItem>
            <ListItem>
              У разі, якщо Замовлення анульоване Покупцем або відхилене Продавцем, сплачена вартість Товару підлягає поверненню, а вже витрачені кошти на доставку, понесені до моменту анулювання Замовлення Покупцем, поверненню не підлягають.
              <OrderedList>
                <ListItem>
                  У випадку, коли оплачене Покупцем Замовлення було відправлене до обраного Покупцем відділу служби доставки, але Покупець відмовився від огляду та прийняття Замовлення, таке Замовлення вважається анульованим з ініціативи Покупця відповідно до п. 3.7. цієї Угоди, а сплачені Покупцем кошти за Замовлення підлягають поверненню за відрахуванням вартості послуг доставки і повернення Замовлення до відділу служби доставки.
                </ListItem>
                <ListItem>
                  У випадку відмови Покупця від отримання Замовлення у відділі служби доставки без пред’явлення та оформлення претензії до служби доставки Покупцем відповідно до п. 3.9. цієї Угоди, така відмова Покупця від отримання Замовлення вважається анулюванням Замовлення з ініціативи Покупця відповідно до п. 3.7. цієї Угоди, а сплачені Покупцем кошти за Замовлення підлягають поверненню за відрахуванням вартості послуг доставки і повернення Замовлення до відділу служби доставки.
                </ListItem>
              </OrderedList>
            </ListItem>
            <ListItem>
              Умови оплати Контенту
              <OrderedList>
                <ListItem>
                  Отримання доступу до перегляду каталогу Контенту, розміщеного на www.barkovbooks.com у відповідному розділі, є безплатним для Користувачів Сайту, а плата стягується за отримання доступу до завантаження обраних файлів Контенту у представлених на сайті форматах.
                </ListItem>
                <ListItem>
                  Оплата за платний Контент здійснюється банківською картою Visa або MasterCard на Сайті в момент оформлення Замовлення.
                </ListItem>
                <ListItem>
                  У випадку здійснення Покупцем оплати за надання доступу до завантаження Контенту та неможливості його безпосередньо завантажити з технічних чи будь-яких інших причин Покупцем (що виникли на стороні та з вини Покупця), повернення сплачених грошових коштів не проводиться, а Контент буде вважатися таким, що отриманий належним чином. Повернення сплачених грошових коштів можливе лише у тому випадку, якщо Продавцем був наданий неробочий файл (який неможливо відтворити чи зберегти (якщо це доведено після перевірки Продавцем) та у разі, якщо Продавець не може здійснити заміну такого файлу. Таким чином, Контент належної якості поверненню та обміну не підлягає.
                </ListItem>
                <ListItem>
                  Ціна на Контент може змінюватися незалежно від того чи був він акційним чи ні. Продавець не компенсує Покупцю вартість придбаного Контенту в разі, якщо з часом цей Контент стає акційним та його вартість суттєво знижується. Покупець Контенту розуміє та погоджується, що після закінчення певного періоду ціна акційного Контенту може змінюватися, а безплатним акційний Контент може стати платним і навпаки.
                </ListItem>
                <ListItem>
                  Ціни на Контент можуть змінюватись без попередження Покупця Контенту. Якщо зниження ціни відбувається після придбання Покупцем Контенту, Адміністрація Сайту не зобов'язана здійснювати будь-які компенсації такому Покупцю Контенту.
                </ListItem>
              </OrderedList>
            </ListItem>
            <ListItem>
              При анулюванні Замовлення чи проведенні повернення товару грошові кошти підлягають поверненню Покупцю, з урахуванням умов п. 3.7. цієї Угоди і вимог чинного законодавства України.
            </ListItem>
            <ListItem>
              При поверненні товару грошові кошти підлягають поверненню Покупцю тільки після отримання товару та обробки Продавцем належним чином заповненої заяви на повернення.
            </ListItem>
            <ListItem>
              Повернення грошових коштів може відбуватися одним з вказаних нижче способів: на банківську карту, з якої була проведена оплата Покупцем; шляхом здійснення поштового переказу. Замовлення оплачене повністю або частково за допомогою Бонусного рахунку — на Бонусний рахунок не повертається.
            </ListItem>
            <ListItem>
              Термін повернення грошових коштів – до 30 (тридцяти) робочих днів.
            </ListItem>
            <ListItem>
              Додаткові правила та умови повернення грошових коштів викладені у відповідних розділах Сайту.
            </ListItem>
            <ListItem>
              Продавець має право за придбання товару на Сайті нарахувати бонуси Покупцю. У випадку анулювання Покупцем Замовлення, повернення Покупцем Замовлення тощо, Продавець має право запропонувати Покупцю замість повернення сплачених грошових коштів нарахувати на Бонусний рахунок Покупця відповідну кількість бонусів (у розмірі сплачених Покупцем грошових коштів). Порядок нарахування, використання, припинення дії бонусів та використання Бонусного рахунку, інформація про Бонусну програму BarkovBooks розміщено у відповідних розділах Сайту.
            </ListItem>
            <ListItem>
              Продавець може обмежувати можливість використання деяких зі способів здійснення оплати замовленого Товару (п. 3.4.).
            </ListItem>
          </OrderedList>
        </ListItem>

        <ListItem>
          <SectionTitle>Порядок передачі товару</SectionTitle>
          <OrderedList>
            <ListItem>
              Доставка товару здійснюється по всій території України, за винятком АР Крим, тимчасово окупованих територій України та населених пунктів, в яких на момент здійснення покупки Товару не функціонують належним чином поштові служби доставки.
            </ListItem>
            <ListItem>
              Доставка Замовлення товару здійснюється протягом 5 (п'яти) календарних днів з моменту обробки та узгодження Замовлення Продавцем з Покупцем, за вказаною Покупцем адресою.
            </ListItem>
            <ListItem>
              Доступ до скачування Контенту Покупцю надається одразу після оплати такого Контенту, Контент зберігається у Особистому кабінеті Покупця у відповідному розділі без обмеження у часі. Таким чином з моменту появи можливості скачати Контент та появи його в Особистому кабінеті вважається, що Продавцем було надано доступ до Контенту в повному обсязі.
            </ListItem>
            <ListItem>
              При оформленні Замовлення Покупець має можливість самостійно обрати спосіб доставки, а саме: кур'єрська доставка (вручення кур’єром за адресою, вказаною Покупцем); отримання товару у обраному відділенні служби доставки (відділення служби доставки можливо обрати зі списку зазначених на Сайті); самовивіз з відділення BarkovBooks.com. (адреси вказані у відповідному розділі на Сайті).
            </ListItem>
            <ListItem>
              Вартість доставки товарів проводиться за тарифами Компаній, які безпосередньо здійснюють доставку товару. Вся необхідна інформацію відносно доставки товарів зазначається Покупцем під час оформлення Замовлення у розділі «Оформлення замовлення» на Сайті.
            </ListItem>
            <ListItem>
              Продавець докладає всіх зусиль для дотримання термінів доставки, вказаних на Сайті, однак, затримки доставки можливі внаслідок непередбачуваних обставин, які перебувають поза контролем Продавця (обставини форс-мажору). Продавець інформує Покупця, в разі виникнення форс-мажорних обставин і погоджує нові умови доставки по електронній пошті або за допомогою засобів телефонного зв’язку.
            </ListItem>
            <ListItem>
              Моментом отримання товару Покупцем є підписання Одержувачем\Покупцем документа, що підтверджує факт прийняття замовленого ним товару (товарно-транспортна накладна, акт прийому-передачі, декларація на пересилання тощо) або фактично отримання Одержувачем\Покупцем товару та вчинення ним дій, що свідчать про прийняття товару. Для видачі Товару Одержувачу останній зобов'язаний пред'явити при отриманні Товару документ, що засвідчує особу (паспорт).
            </ListItem>
            <ListItem>
              Перед відправкою Покупцем товару, він перевіряється і страхується на повну вартість. При отриманні товару Покупець зобов'язується перевірити товар на наявність пошкоджень, а також наявність комплекту необхідних документів (товарний чек, гарантійний талон, акт прийому-передачі тощо) і в разі виявлення невідповідностей на місці пред'явити та належним чином оформити претензії службі доставки відповідно до формату та правил служби доставки щодо оформлення таких претензій (заява, протокол, акт, претензія тощо). Продавець не несе відповідальність за дії Компаній, що забезпечують доставку товару Покупцям.
            </ListItem>
            <ListItem>
              Покупець має право порушити цілісність пакування товару, провести огляд товару, а також розпорядитися товаром будь-яким іншим способом на власний розсуд, тільки після його повної оплати. Визначене положення не позбавляє Покупця прав, передбачених Законом України «Про захист прав споживачів» щодо повернення товару належної і неналежної якості.
            </ListItem>
            <ListItem>
              Покупець має право призначити Одержувачем придбаного товару третю особу. У цьому випадку Покупець зобов'язаний вказати в формі Замовлення дані, необхідні для ідентифікації Одержувача і доставки йому товару. На відносини сторін, в такому випадку, поширюються положення ст. 636 Цивільного кодексу України.
            </ListItem>
            <ListItem>
              Надання доступу до завантаження Контенту.
              <OrderedList>
                <ListItem>
                  Надання доступу до завантаження Контенту надається тільки після повної оплати такого Контенту Покупцем.
                </ListItem>
                <ListItem>
                  Кількість завантажень файлів Контенту, що придбані Покупцем від окремих Правовласників (безпосередніх власників контенту) може бути обмежена. Інформація про обмеження кількості завантажень Контенту може бути надана додатково. У разі перевищення допустимої кількості завантажень Покупцем Контенту доступ до придбаного файлу Контенту буде припинено. Якщо перевищення допустимої кількості завантажень відбулося з технічних причин (наприклад, через нестабільне з'єднання або проблеми з програмним забезпеченням зі сторони Покупця Контенту), Адміністрація сайту залишає за собою право, але не зобов'язана, надати такому Покупцю контенту можливість здійснити одне додаткове завантаження.
                </ListItem>
                <ListItem>
                  Файли Контенту надаються для завантаження Покупцям Контенту у тому вигляді у якому були отримані від правовласників. Продавець зобов'язується надати доступ до Контенту в одному або декількох із можливих варіантів форматів файлів Контенту на свій вибір. Продавець не несе відповідальності за неможливість завантаження файлу Контенту у певному форматі незалежно від того, чи був заявлений цей формат у списку доступних для цього твору. Продавець/Правовласник/Власник прав інтелектуальної власності не несе відповідальності за зміст Контенту.
                </ListItem>
                <ListItem>
                  В окремих випадках на вимогу Правовласника Адміністрація залишає за собою право видалити з Особистого кабінету Покупця певний Контент або здійснити заміщення Контенту.
                </ListItem>
              </OrderedList>
            </ListItem>
            <ListItem>
              Продавець може обмежувати можливість використання деяких з способів доставки Товару при оформленні Замовлення (п. 4.4.).
            </ListItem>
            <ListItem>
              «Доставка 365» є платною послугою, що надається Продавцем, яка діє на тимчасовій основі (на основі підписки) та за якою Продавець зобов’язується за власний рахунок здійснити доставку Товару для такого Користувача. Послуга «Доставка 365» надається за одночасного дотримання таких умов:
              <OrderedList>
                <ListItem>
                  Сплати Користувачем плати за підписку послуги «Доставка 365», яка встановлена на відповідній веб-сторінці Сайту.
                </ListItem>
                <ListItem>
                  Належної верифікації Користувача під час здійснення Замовлення в Обліковому записі, з якого було здійснено оплату послуг «Доставка 365».
                </ListItem>
                <ListItem>
                  Здійснення Користувачем Замовлення Товару на загальну суму яка дорівнює або є більшою мінімальної суми для використання послуги, встановленої на відповідній веб-сторінці Сайту з урахуванням всіх знижок та акційних пропозицій.
                </ListItem>
                <ListItem>
                  Відповідність адреси доставки Товару територіальним вимогам (обмеженням) «Доставка 365», які встановлені на відповідній веб-сторінці Сайту.
                </ListItem>
              </OrderedList>
            </ListItem>
            <ListItem>
              Строк дії послуги «Доставка 365» встановлений на відповідній веб-сторінці Сайту.
            </ListItem>
            <ListItem>
              «Доставка 365» покриває лише вартість отримання та доставки Товару. Всі замовлені Користувачем Товари оплачуються окремо.
            </ListItem>
            <ListItem>
              Користувач може достроково припинити дію послуги «Доставка 365». Вартість послуги «Доставка 365» не повертається в разі дострокового припинення дії послуги, а послуга вважається виконаною в момент підтвердження Продавцем та/або Адміністрацією Сайту початку дії такої послуги.
            </ListItem>
            <ListItem>
              Адміністрація може в односторонньому порядку і в будь-який час змінювати правила й умови, що діють стосовно послуги «Доставка 365», попередньо сповістивши про це зареєстрованих Користувачів. Зміни, внесені до правил і умов, застосовуватимуться як до поточних, так і до нових Користувачів Сайту.
            </ListItem>
            <ListItem>
              Послуга «Доставка 365» призначена для використання належним чином ідентифікованим через Особистий кабінет Користувачам. Передача права на користування послугою третім особам суворо заборонена.
            </ListItem>
            <ListItem>
              Адміністрація залишає за собою право достроково припинити дію послуги «Доставка 365» для конкретного Користувача в наслідок порушення таким Користувачем умов цієї Угоди, заздалегідь повідомивши про це такого Користувача.
            </ListItem>
          </OrderedList>
        </ListItem>

        <ListItem>
          <SectionTitle>Гарантійні умови</SectionTitle>
          <OrderedList>
            <ListItem>
              За умови дотримання вимог щодо належної експлуатації товару Покупцем, Продавець гарантує високу якість товару протягом терміну гарантії. Термін гарантії на товар становить 14 (чотирнадцять) календарних днів, якщо інше не встановлено виробником (постачальником) та/або законодавством чи не зазначено на Сайті.
            </ListItem>
            <ListItem>
              Гарантійний термін починається з моменту передачі товару Покупцю, що вказується у відповідному документі, а якщо момент передачі сезонного товару Покупцю не збігається з початком сезону для такого товару, — з початку відповідного сезону. Вся необхідна інформація відносно гарантійних умов щодо придбаних на Сайті товарів зазначається у відповідних розділах Сайту.
            </ListItem>
            <ListItem>
              Контент гарантійного терміну не має.
            </ListItem>
          </OrderedList>
        </ListItem>

        <ListItem>
          <SectionTitle>Повернення товару</SectionTitle>
          <OrderedList>
            <ListItem>
              У разі, якщо товар не відповідає очікуванням Покупця, він має право повернути придбаний товар належної якості протягом 14 (чотирнадцять) календарних днів з дня його отримання, при дотриманні умов, передбачених Законом України «Про захист прав споживачів».
            </ListItem>
            <ListItem>
              Не підлягають поверненню товари належної якості, визначені Постановою Кабінету Міністрів України «Про реалізацію окремих положень Закону України «Про захист прав споживачів» від 19.03.1994 р № 172.
            </ListItem>
            <ListItem>
              Не підлягає поверненню Контент після його оплати на Сайті Покупцем.
            </ListItem>
            <ListItem>
              Для здійснення повернення товару Покупець має повідомити про це шляхом здійснення дзвінка на відповідний номер, що вказано на Сайті або повідомити про це на адресу електронної пошти: support@barkovbooks.com з позначкою «Вимога Повернення товару».
            </ListItem>
            <ListItem>
              Товар, що повертається повинен мати товарний вигляд, повинні бути збережені ярлики, бирки, упаковка зі штрих-кодом, товар не повинен мати слідів використання і т.п.
            </ListItem>
            <ListItem>
              При поверненні (відправлення за допомогою служби доставки) товару, що поставляється в індивідуальній упаковці (упаковці виробника), необхідно упакувати такий товар додатково та зберегти вид товару в індивідуальній упаковці. Продавець має право відмовити у прийманні товару, що повертається, якщо він був запакований неналежним чином, внаслідок чого на ньому (на індивідуальній упаковці) залишилися сліди і/або пошкодження (в т.ч. виникають при його транспортуванні (подряпини, прим'ятості, нанесення маркувань, додаткова фіксація скотчем вантажу і/або супровідних документів та ін.) — як товар, товарний вигляд якого не збережено Покупцем.
            </ListItem>
            <ListItem>
              Повернення товару неналежної якості.
              <OrderedList>
                <ListItem>
                  Повернення товару неналежної якості здійснюється протягом встановленого гарантійного строку для цього виду товару, в порядку і в терміни, встановлені законодавством, супровідними документами на товар та/або зазначені Постачальником при наданні інформації про товар.
                </ListItem>
                <ListItem>
                  У разі виявлення протягом гарантійного строку істотних недоліків, які виникли з вини виробника товару або через його фальсифікації, підтверджених при необхідності висновком експертизи, Продавець, в порядку і в терміни, встановлені законодавством, і на підставі обов'язкових для сторін правил і/або даної Публічної оферти, повертає Покупцю сплачену за товар грошову суму.
                </ListItem>
                <ListItem>
                  Вимоги Покупця повинні бути пред'явлені шляхом направлення письмової заяви за адресою: 04200, м Київ, вул. Дубровицька, 28, 3 поверх. на ім'я Адміністратора. У випадку отримання Покупцем Товару неналежної якості у відділі служби доставки, Покупець зобов’язаний також пред’явити та оформити претензію до такої служби доставки відповідно до вимог п. 4.8. цієї Угоди. У випадку невиконання Покупцем умов п. 4.9. цієї Угоди, відмова Покупця від Товару вважатиметься анулюванням Замовлення з ініціативи Покупця відповідно до п. 3.7. цієї Угоди.
                </ListItem>
                <ListItem>
                  Якщо разом з товаром Покупцеві було надано технічний паспорт, гарантійний талон або інший документ, вимоги Покупця розглядаються Продавцем тільки за умови надання зазначених документів.
                </ListItem>
                <ListItem>
                  Продавець має право відмовитися від приймання товару, відправленого Покупцем без надання вищевказаних документів, а також не розглядати заяву (претензію) Покупця до усунення допущених ним недоліків. У разі, якщо Покупець не надішле вказані документи протягом 1 (одного) місяця, зобов'язання Продавця щодо забезпечення збереження такого надісланого товару припиняються, і він має право розпорядитися товаром на власний розсуд. Продавець не зобов'язаний здійснювати зворотну відправку товару, заяву за яким оформлено неналежним чином та не надані належні документи.
                </ListItem>
                <ListItem>
                  Вимоги Покупця не підлягають задоволенню, якщо Продавець доведе, що дефекти товару виникли внаслідок порушення Покупцем правил використання товару, умов його зберігання або умов його повернення.
                </ListItem>
                <ListItem>
                  Вимоги Покупця розглядаються протягом 14 робочих днів з моменту їх отримання.
                </ListItem>
              </OrderedList>
            </ListItem>
            <ListItem>
              Додатково необхідна інформація відносно повернення товару міститься у відповідних розділах Сайту.
            </ListItem>
          </OrderedList>
        </ListItem>

        <ListItem>
          <SectionTitle>Доступ до Сайту</SectionTitle>
          <OrderedList>
            <ListItem>
              Адміністрація докладає всіх можливих зусиль для забезпечення належного функціонування Сайту, проте не несе відповідальності за невиконання або неналежне виконання зобов'язань передбачених цією Угодою, а також за шкоду, завдану у зв'язку з цим, внаслідок, але не обмежуючись: неправомірними діями третіх осіб; збоями в роботі Сайту, зумовленими помилками в коді, комп'ютерними вірусами та іншими сторонніми фрагментами коду в програмному забезпеченні Сайту; відсутністю інтернет-з'єднань між пристроєм Користувача і сервером Сайту, а також між сервером Сайту і мережею Інтернет; проведенням державними органами та іншими належним чином уповноваженими організаціями оперативних заходів, що впливають на роботу Сайту; виконанням оновлень програмного забезпечення Сайту; за застосовним і таким, що набув чинності, рішенням уповноважених органів державної влади.
            </ListItem>
            <ListItem>
              З метою недопущення неавторизованого автоматичного сканування Сайту, а також використання Сайту з метою проведення шахрайських дій та у разі наявності обґрунтованої підозри у зловживаннях з боку Користувача, щодо використання Сайту (в тому числі порушення прав інтелектуальної власності Адміністрації та третіх осіб на Контент) Адміністрація залишає за собою право: заблокувати доступ до Сайту; скасувати всі покупки, здійснені шляхом використання неавторизованого доступу; стягнути відшкодування збитків, завданих використанням неавторизованого доступу до Сайту; заблокувати користування Бонусним рахунком.
            </ListItem>
            <ListItem>
              Обліковий запис на Сайті передбачає можливість його використання виключно одним Користувачем Сайту. Не допускається передача даних Облікового запису третім особам. У разі виявлення фактів передачі даних Облікового запису третім особам або фактів колективного користування Обліковим записом, Адміністрація має право заблокувати цей Обліковий запис і скасувати покупки, зроблені за допомогою такого Облікового запису.
            </ListItem>
          </OrderedList>
        </ListItem>

        <ListItem>
          <SectionTitle>Форс – мажорні обставини</SectionTitle>
          <OrderedList>
            <ListItem>
              Сторони звільняються від відповідальності за повне або часткове невиконання своїх зобов'язань за цією Офертою, якщо таке невиконання стало наслідком обставин непереборної сили, що виникли після укладання даної Оферти та які Сторони не могли ані передбачити, ані попередити розумними заходами.
            </ListItem>
            <ListItem>
              Форс-мажорними обставинами (обставинами непереборної сили) є надзвичайні та невідворотні обставини, що об'єктивно унеможливлюють виконання зобов'язань, передбачених умовами договору (контракту, угоди тощо), обов'язків згідно із законодавчими та іншими нормативними актами, а саме: загроза війни, збройний конфлікт або серйозна погроза такого конфлікту, включаючи але не обмежуючись ворожими атаками, блокадами, військовим ембарго, дії іноземного ворога, загальна військова мобілізація, військові дії, оголошена та неоголошена війна, дії суспільного ворога, збурення, акти тероризму, диверсії, піратства, безлади, вторгнення, блокада, революція, заколот, повстання, масові заворушення, введення комендантської години, карантину, встановленого Кабінетом Міністрів України, експропріація, примусове вилучення, захоплення підприємств, реквізиція, громадська демонстрація, блокада, страйк, аварія, протиправні дії третіх осіб, пожежа, вибух, тривалі перерви в роботі транспорту, регламентовані умовами відповідних рішень та актами державних органів влади, закриття морських проток, ембарго, заборона (обмеження) експорту/імпорту тощо, а також викликані винятковими погодними умовами і стихійним лихом, а саме: епідемія, сильний шторм, циклон, ураган, торнадо, буревій, повінь, нагромадження снігу, ожеледь, град, заморозки, замерзання моря, проток, портів, перевалів, землетрус, блискавка, пожежа, посуха, просідання і зсув ґрунту, інші стихійні лиха тощо.
            </ListItem>
            <ListItem>
              Наявність та строк дії Форс-мажорних обставин підтверджується сертифікатом Торгово-промислової палати України встановленого зразка, наказами Президента України, наказами Кабінету Міністрів України, тощо.
            </ListItem>
            <ListItem>
              Покупець погоджується з тим, що в разі якщо Продавець в зв'язку з настанням Форс-мажорних обставин не зміг виконати замовлення Покупця то в даному випадку грошові кошти сплачені за товар Покупцю не повертаються, при цьому замість цього Продавець нараховує на Бонусний рахунок Покупця відповідну кількість бонусів (у розмірі сплачених Покупцем грошових коштів). Порядок нарахування, використання, припинення дії бонусів та використання Бонусного рахунку, інформація про Бонусну програму BarkovBooks розміщено у відповідних розділах Сайту.
            </ListItem>
          </OrderedList>
        </ListItem>

        <ListItem>
          <SectionTitle>Відповідальність Сторін</SectionTitle>
          <OrderedList>
            <ListItem>
              Покупець/Користувач Сайту, погоджується та гарантує не робити будь-яких дій, які можуть розглядатися як порушують українське законодавство або норми міжнародного права, в тому числі в сфері інтелектуальної власності, авторських і/або суміжних правах, а також будь-яких дій, які призводять або можуть призвести до порушення нормального функціонування Сайту і його сервісів.
            </ListItem>
            <ListItem>
              Покупець/Користувач зобов'язаний своєчасно проінформувати Адміністрацію Сайту про несанкціонований доступ до Особистого кабінету Користувача/Покупця третіми особами. Для інформування Покупець/Користувач повинен звернутися в Службу підтримки за координатами, вказаними на Сайті.
            </ListItem>
            <ListItem>
              Користувач не має права передавати право користування власним Особистим кабінетом третім особам. У разі виявлення фактів передачі даних Облікового запису третім особам або фактів колективного користування Особистим кабінетом Адміністрація має право заблокувати цей Обліковий запис і скасувати покупки, зроблені за допомогою такого Облікового запису.
            </ListItem>
            <ListItem>
              Користувачу/Покупцю заборонено пропонувати або використовувати інформацію, розміщену на Сайті (в тому числі Контент), з комерційною метою без письмової згоди її авторів/правовласників і Адміністрації Сайту, а також будь-яким іншим чином поширювати отриманий Контент, його копії.
            </ListItem>
            <ListItem>
              Приймаючи умови Угоди Користувач/Покупець підтверджує, що ознайомлений і згоден із умовами цієї Угоди.
            </ListItem>
            <ListItem>
              Коментарі та інші записи Користувача/Покупця на Сайті не повинні суперечити вимогам законодавства України та загальноприйнятих норм моралі та моральності.
            </ListItem>
            <ListItem>
              Використання матеріалів Сайту без письмової згоди Адміністрації не допускається. При погодженому цитуванні матеріалів Сайту, посилання на Сайт є обов'язковим.
            </ListItem>
            <ListItem>
              Користувач/Покупець несе відповідальність за достовірність даних, зазначених у реєстраційній формі та формі Замовлення. У разі, якщо некоректне, неточне і/або неправильне зазначення даних в Замовленні призвело до додаткових витрат Продавця, пов'язаних з доставкою товару за невірно вказаною адресою або видачу товару невірно вказаному Одержувачу, всі пов'язані з цим збитки та витрати покладаються на Користувача/Покупця. Продавець має право утримувати суму таких збитків або витрат з сум, сплачених Покупцем в якості оплати товару.
            </ListItem>
            <ListItem>
              Відповідальність за грошові перекази, які здійснює Платник, повністю лежить на банківських установах і платіжних системах, послугами яких вирішує скористатися Платник. Продавець не бере на себе відповідальність за їх дії.
            </ListItem>
            <ListItem>
              Адміністратор не несе відповідальності за роботу інтернет провайдерів, процесингових центрів, платіжних систем, операторів зв'язку, банківських установ, сервісів оплати Visa/MasterCard, в результаті яких необхідна інформація, дані не надійшли або надійшли із запізненням, були загублені або пошкоджені. Будь-які претензії і суперечки щодо проведення платежів і отримання грошових повернень Платник надсилає такій самостійно обраній компанії, а в разі неможливості їх вирішення мирним шляхом вони вирішуються згідно з положеннями Розділу 10 цієї Угоди.
            </ListItem>
            <ListItem>
              Єдиним засобом відшкодування, яке надається Покупцеві в разі невідповідності фактичних умов продажу цій Угоді, є надання Покупцеві/Одержувачу права відмовитися від отримання відповідного товару та вимагати повернення сплаченої за нього вартості. Покупець/Одержувач має право скористатися даним правом до моменту підписання документів, що підтверджують отримання товару.
            </ListItem>
            <ListItem>
              Адміністратор сайту не несе відповідальність за працездатність обладнання, на якому розміщений Сайт, доступність Сайту, роботу каналів передачі даних та інші технічні засоби для здійснення Користувачами доступу до Сайту.
            </ListItem>
            <ListItem>
              Відповідальність Адміністратора не може перевищувати вартості придбаних товарів на Сайті та не включає будь-яку упущену вигоду, непрямі збитки, шкоду завдану третім особам.
            </ListItem>
            <ListItem>
              Продавець не несе відповідальність за дії компаній, що забезпечують доставку товару Одержувачу/Покупцю, в тому числі за терміни доставки, а також за збереження цілісності товару при перевезенні службами доставки.
            </ListItem>
            <ListItem>
              Відповідальність Продавця за зміни умов пропонування до продажу та продажу товару обмежується правом Користувача/Одержувача/Покупця відмовитися від придбання товару і вимагати повернення сплачених за нього грошових коштів.
            </ListItem>
          </OrderedList>
        </ListItem>

        <ListItem>
          <SectionTitle>Вирішення суперечок і застосовне право</SectionTitle>
          <OrderedList>
            <ListItem>
              Ця Угода складена відповідно до законодавства України. Користувач/Покупець, який перебуває за межами цієї юрисдикції, повністю погоджується підпорядкувати правовідносини, що виникають під час будь-якого користування Сайтом, законодавству України, а ці Умови діють щодо нього в максимальному дозволеному його юрисдикцією обсязі без застосування будь-яких колізійних норм.
            </ListItem>
            <ListItem>
              Сторони підтверджують, що в разі якщо будь-яка умова цього договору стане або буде визнана недійсною у зв'язку з невідповідністю закону, ця умова не братиметься до уваги або ж Сторонами будуть вживатись заходи зі зміни договору в тій мірі, щоб зробити договір дійсним і зберегти в повному обсязі наміри Сторін.
            </ListItem>
            <ListItem>
              Користувач/Покупець визнає і погоджується, що вирішення всіх можливих суперечок, які виникли з відносин між Сторонами і залагодити які Сторони не змогли шляхом переговорів протягом як мінімум 30 днів, підлягають вирішенню відповідно до чинного законодавства України.
            </ListItem>
            <ListItem>
              Будь-які претензії та суперечки щодо надання доступу до завантаження Контенту Покупець/Користувач надсилає до Адміністрації, а в разі неможливості їх вирішення мирним шляхом вони вирішуються згідно законодавства України.
            </ListItem>
          </OrderedList>
        </ListItem>

        <ListItem>
          <SectionTitle>Використання персональних даних Користувача</SectionTitle>
          <OrderedList>
            <ListItem>
              Інформація, вказана Користувачем у реєстраційній формі (ПІБ, номер мобільного телефону, e-mail, поштова адреса і т.п.), є його персональними даними. Персональні дані Користувача є конфіденційною інформацією, збір і подальша обробка персональних даних здійснюється Адміністрацією відповідно до Закону України «Про захист персональних даних» та інших нормативно-правових актів України. Джерелом збору персональних даних є інформація, безпосередньо і добровільно надана Користувачем.
            </ListItem>
            <ListItem>
              Метою Обробки персональних даних є забезпечення Адміністрацією можливості ідентифікації Користувача власної інформації на Сайті, забезпечення можливості Адміністрації надавати необхідні для продажу Товару і Контенту, послуги на Сайті, забезпечення можливості Користувача на отримання технічної та консультативної підтримки щодо використання Сайту, а також забезпечення Адміністрацією надання послуг та виконання своїх зобов'язань відповідно до умов цієї Угоди.
            </ListItem>
            <ListItem>
              Своєю згодою з цією Угодою Користувач добровільно надає Адміністрації зазначені в реєстраційній формі персональні дані для реєстрації в інформаційній системі в якості Користувача, а також з метою підтримки довгострокового співробітництва з Адміністрацією Сайту. Користувач також дає безстрокову згоду на використання його персональних даних для обробки Замовлень на придбання товарів, отримання рекламних та спеціальних пропозицій, інформації про акції, розіграші, іншої інформації про діяльність Адміністрації.
            </ListItem>
            <ListItem>
              Користувач надає Адміністрації право здійснювати обробку його персональних даних, в тому числі: записувати персональні дані в бази даних Адміністрації (без додаткового повідомлення Користувача про це), здійснювати довічне зберігання даних, їх накопичення, оновлення, зміну (у разі необхідності).
            </ListItem>
            <ListItem>
              Власником наданих Користувачем персональних даних є ТОВ «Сітон», яке зареєстроване в Україні та офіс якого розташований за адресою: 04200, м. Київ, вул. Дубровицька, 28.
            </ListItem>
            <ListItem>
              У разі зміни своїх персональних даних Користувач повинен надати Адміністрації оновлену інформацію, звернувшись за телефоном Служби підтримки Адміністрації або шляхом внесення змін у відповідний розділ Облікового запису Користувача на Сайті. У разі невиконання Користувачем даної вимоги, Адміністрація не несе відповідальності за несприятливі наслідки, пов'язані з використанням застарілих даних.
            </ListItem>
            <ListItem>
              Користувач/Покупець безпосередньо після реєстрації або в будь-який інший момент може встановити заборону (обмеження) на використання його персональних даних. Для цього Користувач повинен звернутися до Служби підтримки, за телефоном вказаним на Сайті, з відповідним повідомленням. Користувачу також надаються інші права, передбачені статтею 8 Закону України «Про захист персональних даних».
            </ListItem>
            <ListItem>
              Адміністрація не приймає реєстраційні данні Користувача у випадку їх некоректного заповнення.
            </ListItem>
            <ListItem>
              Адміністрація зобов'язується вчасно інформувати Користувача про його можливості та винагороди, однак не несе відповідальності за повідомлення, які не були доставлені Користувачу в результаті незалежних від Адміністрації обставин.
            </ListItem>
            <ListItem>
              Для цілей, передбачених п. 11.2. цієї Угоди, Користувач надає Адміністрації право направляти йому будь-яку інформацію комерційного і / або інформаційного характеру, а також інформацію про інші споживчі пропозиції поштою, електронною поштою, телефоном, SMS, viber-повідомлення здійснювати дзвінки на вказаний в реєстраційній формі/Обліковому записі телефонний мобільний номер.
            </ListItem>
            <ListItem>
              Дані Користувача, зазначені у реєстраційних даних є конфіденційними. Доступ до даних мають виключно уповноважені особи Адміністрації і сам Користувач, а також ці дані можуть бути надані на вимогу правоохоронних та/або інших органів відповідно до чинного законодавства.
            </ListItem>
            <ListItem>
              Відповідальність за недостовірність даних у Обліковому записі несе Користувач.
            </ListItem>
            <ListItem>
              Адміністрація має право надати дозвіл на обробку персональних даних третім особам (в тому числі Продавцю) за умови дотримання такою третьою особою правил та умов цієї Угоди.
            </ListItem>
            <ListItem>
              Реалізація прав Користувача як суб'єкта персональних даних, передбачених Законом України «Про захист персональних даних» можлива шляхом надсилання Користувачем Адміністрації відповідного звернення за реквізитами Адміністрації вказаними в п. 11.5. цієї Угоди.
            </ListItem>
          </OrderedList>
        </ListItem>

        <ListItem>
          <SectionTitle>Інші умови</SectionTitle>
          <OrderedList>
            <ListItem>
              Всі правила і умови здійснення/виконання окремих дій/операцій, розміщені у відповідних розділах Сайту, є невід'ємними частинами (як Додатки) даної Угоди, що визначають зобов'язання для обох Сторін. У разі якщо умови, зафіксовані в тексті цієї Угоди, і умови, зазначені в його Додатках (розділах сайту), відрізняються, Сторони керуються умовами, визначеними в Додатках. Продаж товару Продавцем Покупцю регулюється цим Договором, а також Законом України «Про електронну комерцію», Законом України «Про захист прав споживачів», Правилами продажу товарів на замовлення та поза торговельними або офісними приміщеннями та іншими законодавчими актами в частині, що не суперечить специфіці електронної комерції.
            </ListItem>
            <ListItem>
              Оформляючи Замовлення Покупець підтверджує, що: він ознайомлений та згоден з усіма умовами, викладеними в даній Публічної оферти, і беззастережно їх приймає; всі дії, які їм будуть здійснені, не суперечитимуть умовам даної Угоди.
            </ListItem>
            <ListItem>
              Адміністрація має право без попереднього повідомлення вносити зміни в текст даної Угоди і/або Додатків. Зміни в Публічну оферту вступають в силу після їх публікації і застосовуються до будь-якого Замовлення, зробленого після їх публікації.
            </ListItem>
            <ListItem>
              Користувач зобов'язується уважно ознайомитися з даною Угодою. У разі незгоди з її умовами Користувач зобов'язується негайно припинити використання Сайту.
            </ListItem>
            <ListItem>
              Продавець і Покупець підтримують зв'язок за допомогою використання електронної пошти, телефонного зв'язку (SMS і т.д), додатків, оголошень і/або повідомлень. Покупець погоджується, що всі повідомлення, дані або інша інформація, що надається в електронному вигляді, мають юридичну силу і прирівнюються до документів, складених в письмовій формі з урахуванням положень п. 1.5. цієї Угоди.
            </ListItem>
            <ListItem>
              Зареєструвавшись на Сайті, Покупець надає свою згоду на отримання оновленої інформації, інформаційних бюлетенів з останніми новинами, новими надходженнями, спеціальними пропозиціями та оголошеннями про продаж через будь-які засоби зв'язку, включаючи електронні повідомлення (e-mail), SMS тощо.
            </ListItem>
            <ListItem>
              Якщо Покупець бажає відмовитися від розсилки повідомлень, що стосуються цієї Угоди/Сайту, він повинен звернутися у Службу підтримки зателефонувавши або направивши електронного листа на електронну пошту, що вказана на Сайті, з проханням відписати його від розсилки. Запит буде виконаний протягом доби з моменту його надходження.
            </ListItem>
            <ListItem>
              Адміністрація залишає за собою право блокувати Покупця (позбавити його можливості замовляти і купувати товари), звертатися з відповідними заявами в правоохоронні органи і передавати їм дані такого Покупця в разі, якщо будь-які дії Покупця, на думку Продавця, носять ознаки шахрайства та можуть завдати шкоди інтересам інших Користувачів/Покупців чи третіх осіб.
            </ListItem>
            <ListItem>
              Визнання судом будь-якого положення Угоди недійсним, не тягне недійсності інших положень Угоди.
            </ListItem>
          </OrderedList>
        </ListItem>
      </OrderedList>
    </TermsContainer>
  );
};

export default TermsOfUse;